import React from "react";
import { useFetchAsset } from "@hooks/useFetchAsset";
import { usePartnerStackCookies } from "./usePartnerStackCookies";
import { ORGANIZATION_PREVIEW_URL, PRODUCT_PREVIEW_URL } from "./constants";
import { OnboardingMode, useOnboardingMode } from "./useOnboardingMode";
import { RegistrationContainer } from "./containers/RegistrationContainer";
import { OnboardingContainer } from "./containers/OnboardingContainer";
import { InviteOnboardingContainer } from "./containers/InviteOnboardingContainer";
import { BillingOwnerInviteOnboardingContainer } from "./containers/BillingOwnerInviteOnboardingContainer";

export const Onboarding: React.FC = () => {
    usePartnerStackCookies();
    useFetchAsset(PRODUCT_PREVIEW_URL);
    useFetchAsset(ORGANIZATION_PREVIEW_URL);

    const onboardingMode = useOnboardingMode();

    switch (onboardingMode) {
        case OnboardingMode.CREATE_ACCOUNT:
            return <RegistrationContainer />;
        case OnboardingMode.ONBOARDING:
            return <OnboardingContainer />;
        case OnboardingMode.INVITE:
            return <InviteOnboardingContainer />;
        case OnboardingMode.BILLING_OWNER_INVITE:
            return <BillingOwnerInviteOnboardingContainer />;
    }

    return null;
};
